import React, { Component } from 'react';
import BookingItemsTable from "../booking_items/table";
import SplitPaymentsTable from "../split_payments/table";
import Edit from '../bills/edit';
import axios from 'axios';
import PubSub from 'pubsub-js';
import ApproveErrorModal from './approve_error_modal';

export default class Bill extends Component {
  constructor(props) {
    super(props);

    this.path = window.location.pathname;
  }

  componentDidMount() {
    PubSub.subscribe('BookingItem.Updated', this.props.onUpdate)
  }

  handleApprove = (e) => {
    e.preventDefault();

    const { onUpdate, data } = this.props;

    axios
      .post(`${this.path}/bills/${data.id}/approval.json`)
      .then(() => { onUpdate() })
      .catch((error) => {
        PubSub.publish('Bills.ApprovalError', { errors: error.response.data.errors.base })
      });
  };

  handleCancel = (e) => {
    e.preventDefault();

    const { onUpdate, data } = this.props;

    axios
      .delete(`${this.path}/bills/${data.id}.json`)
      .then(() => { onUpdate() })
      .catch((error) => console.log(error));
  };

  handleRemoveBookingItem = (bookingItemId) => {
    const { data, onUpdate } = this.props;
    const { id } = data;

    axios
      .delete(`${window.location.pathname}/bills/${id}/booking_items/${bookingItemId}.json`)
      .then(() => { onUpdate() })
      .catch((error) => console.log(error));
  };

  handleEditBookingItemAttendee = (bookingItemId) => {
    PubSub.publish('BookingItemAttendee.Edit', { id: bookingItemId, modalTitle: 'Edit Attendee' })
  };

  render() {
    const { data, onUpdate } = this.props;

    if (!data) return null;

    const { status } = data;

    let fundEditAttendeeItem = undefined;
    let fundRemoveItem = undefined;

    if (status === 'pending') {
      fundEditAttendeeItem = this.handleEditBookingItemAttendee;
      fundRemoveItem = this.handleRemoveBookingItem;
    }

    return (
      <div style={{ outline: '2px solid #1ea800', margin: '0 -10px 0 -10px', padding: '10px 10px 10px 10px' }}>
        <div className="section">
          <div className="section-header">
            <h3>List of sessions</h3>
          </div>

          <BookingItemsTable
            items={data.booking_items.data}
            billData={data}
            onRemoveItem={fundRemoveItem}
            onEditAttendeeItem={fundEditAttendeeItem}
          />
        </div>

        {data.split_payments.data && data.split_payments.data.length > 1 &&
          <div className="section">
            <div className="section-header">
              <h3>Payment Schedule</h3>
            </div>

            <SplitPaymentsTable
              items={data.split_payments.data}
              included={data.split_payments.included}
            />
          </div>
        }

        {data.edit_price_adjustment &&
          <div>
            <Edit path={this.path} {...data} onUpdate={onUpdate}/>

            <div className="btn-toolbar pull-right">
              <a className="btn btn-danger" href="#" onClick={this.handleCancel}>Cancel</a>
              <a className="btn btn-primary" href="#" onClick={this.handleApprove}>Confirm</a>
            </div>

            <ApproveErrorModal title={'Title'}/>
          </div>
        }

        <div className="clearfix"/>
      </div>
    );
  }
}